import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { GetLicensedProductsQuery } from './graphql/GetLicensedProductsQuery.graphql';
import type { GetLicensedProductsQuery as GetLicensedProductsQueryType } from './graphql/__types__/GetLicensedProductsQuery';

export async function preloadGlobalAppShortcutsLicensedProducts() {
	const { cloudId } = getPreloaderFnContext();

	return query<GetLicensedProductsQueryType, { cloudId: string }>({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: GetLicensedProductsQuery,
		variables: { cloudId },
	});
}
